(function () {
  'use strict';

  angular
    .module('voucherExtranet')
    .config(config);

  function config() {
  }
}());
